import type { ComputedRef, InjectionKey } from 'vue';

/** Size step of a control tile: `compact` for dense walls, `regular` otherwise. */
export type NxControlTileSize = 'compact' | 'regular';

/**
 * Intent tone of a control tile. `neutral` is the plain tile; the others say
 * something about the device — an open window (`warning`), a fault
 * (`danger`), a confirmed state (`success`).
 */
export type NxControlTileTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

/** What an `NxControlTileGrid` hands its tiles: the size they default to. */
export interface NxControlTileGridContext {
  size: ComputedRef<NxControlTileSize>;
}

export const controlTileGridKey: InjectionKey<NxControlTileGridContext> =
  Symbol('nx-control-tile-grid');
